import React from 'react'
import PageHeader from '../../Components/Instructor_Dashboard/PageHeader'
import CommonTable from '../../Components/CommonTable'

const columns = [
    {
        title: '#',
        dataIndex: 'index',
        key: 'index',
        render: (text, record, index) => index + 1,  // Display the index (1-based index)
    },
    {
      title: 'Course Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name), 
    },
    {
      title: 'Instructor revenue',
      dataIndex: 'revenue',
      key: 'age',
      sorter: (a, b) => a.revenue.localeCompare(b.revenue), 
    },
]

const data = [
    {
      key: 1,
      name: 'John Brown',
      revenue:5968
    },
    {
      key: 2,
      name: 'Jim Green',
      revenue:9
    }
]

const Payout_Report = () => {
  return (
    <div className='payout_report_page'>
      <PageHeader title={'Payout report'} btnName={'Request new withdrawl'}/>

      <div className='payment_report_cards_div'>
         
         <div className='payout_report_card-1'>
            <div className='left'>
               <p>Pending amount</p>
               <h2>$57</h2>
            </div>
            <div className='right'>

            </div>
         </div>

         <div className='payout_report_card-2'>
            <div className='left'>
                <p>Total payout amount</p>
                <h2>$57</h2>
            </div>
            <div className='right'>

            </div>
         </div>

         <div className='payout_report_card-3'>
           <div className='left'>
                <p>Request withdrawl amount</p>
                <h2>$57</h2>
            </div>
            <div className='right'>

            </div>
         </div>
      </div>

      <div className='payout_report_page_div'>
        <h4>Payout Report</h4>
        <CommonTable columns={columns} data={data}/>
      </div>

    </div>
  )
}

export default Payout_Report
